import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	RegularFilter,
	TaskExerciseDetailDTO,
	TaskExerciseSeriesDetailDTO,
	TaskScheduledDTO,
	TaskScheduledRequestDTO,
	TaskScheduledRewardDTO,
} from '../DTO/task/regular.interface';
import {
	ChartletFilter,
	GameCartoonStickerSeriesDTO,
} from '../DTO/treasury/chartlet.interface';

export const regularApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getRegularList: builder.query<
			SuccessResponse<Paginated<TaskScheduledDTO>>,
			RegularFilter
		>({
			query: (body) => ({
				url: `/web/task/scheduled/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['RegularList'],
		}),
		getRegularRewardList: builder.query<
			SuccessResponse<Paginated<TaskScheduledRewardDTO>>,
			RegularFilter
		>({
			query: (body) => ({
				url: `/web/task/scheduled/reward/page`,
				method: 'POST',
				body,
			}),
		}),
		createRegular: builder.mutation<
			SuccessResponse<any>,
			TaskScheduledRequestDTO
		>({
			query: (body) => ({
				url: `/web/task/scheduled`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['RegularList'],
		}),
		getRegularDetail: builder.query<SuccessResponse<TaskScheduledDTO>, string>({
			query: (id) => ({
				url: `/web/task/scheduled/${id}`,
				method: 'GET',
			}),

			providesTags: ['RegularDetail'],
		}),
		deletaRegular: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/task/scheduled/${id}`,
				method: 'Delete',
			}),
		}),
		updateRegular: builder.mutation<
			SuccessResponse<any>,
			TaskScheduledRequestDTO
		>({
			query: (body) => ({
				url: `/web/task/scheduled/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['RegularDetail'],
		}),
		getRegularSortList: builder.query<
			SuccessResponse<TaskScheduledDTO>,
			string | number
		>({
			query: (type) => ({
				url: `/web/task/scheduled/list/${type}`,
				method: 'GET',
			}),
		}),
		sortRegular: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/task/scheduled/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['RegularList'],
		}),
		getRegularExerciseList: builder.query<
			SuccessResponse<Paginated<TaskExerciseDetailDTO>>,
			RegularFilter
		>({
			query: (body) => ({
				url: `/web/task/scheduled/exercise/page`,
				method: 'POST',
				body,
			}),
		}),
		getRegularSeriesList: builder.query<
			SuccessResponse<Paginated<TaskExerciseSeriesDetailDTO>>,
			RegularFilter
		>({
			query: (body) => ({
				url: `/web/task/scheduled/exercise-series/page`,
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const {
	useGetRegularListQuery,
	useGetRegularRewardListQuery,
	useCreateRegularMutation,
	useGetRegularDetailQuery,
	useDeletaRegularMutation,
	useUpdateRegularMutation,
	useGetRegularSortListQuery,
	useSortRegularMutation,
	useGetRegularExerciseListQuery,
	useGetRegularSeriesListQuery,
} = regularApiSlice;
